import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { DamsColors } from '../styles/DamsColors';

interface CheckboxProps{
    onChange?: (event: React.SyntheticEvent, checked: boolean)=>void,
    label?: string
    value?:boolean
}
const AuthCheckLabel:React.FC<CheckboxProps>=({onChange,label,value})=> {
    return (
        <FormControlLabel
        onChange={onChange}
            control={<Checkbox sx={styles.checkbox} />}
            label={label}
            value={value}
            componentsProps={{
                typography: {
                    sx: styles.label
                },
            }}
            sx={styles.formControl}
        />
    );
}


const styles = {
    checkbox: {
        padding: 0,
        margin: 0,
        backgroundColor: 'white',
        '&.Mui-checked': {
            color: DamsColors.Authentication.InputBorder,
            backgroundColor: 'white',
        },
        '& .MuiSvgIcon-root': {
            color: DamsColors.Authentication.InputBorder,
            padding: 0,
            margin: 0,
            '&.Mui-checked': {
                color: DamsColors.Authentication.InputBorder,
                backgroundColor: 'white',
            },
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },

    formControl: {
        p: 0,
        m: 0,
    },

    label: {
        fontFamily: 'Inter',
        fontSize: 14,
        fontWeight: 400,
        color: `${DamsColors.Authentication.CheckBoxLabel}`,
        ml: 1,
    }
}


export default AuthCheckLabel;